import { THEME_NAMES } from "../../../themes/config";
import { flowDisabledLoan } from "../../flowDisabledLoan";
import { flowVideoId } from "../../videoIdFlows/flowVideoId";
import { flowVideoIdCaixaBank } from "../../videoIdFlows/flowVideoIdCaixaBank";
import { DISABLED_LOAN_STATUS } from "../constants/DisabledLoanStatus";

export const videoIdFlows = [
  {
    ...flowDisabledLoan,
    condition: (processState, authState) => {
      return DISABLED_LOAN_STATUS.includes(processState?.loan?.status);
    },
  },
  {
    ...flowVideoIdCaixaBank,
    condition: (processState, authState) =>
      authState?.agent?.custom_theme === THEME_NAMES.caixabank,
  },
  {
    ...flowVideoId,
    condition: () => {
      return true;
    },
  },
];
